import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-arrow-up\">\n    <path d=\"M12 3.07031L11.4609 3.58594L5.08594 9.96094L6.16406 11.0391L11.25 5.95312V21H12.75V5.95312L17.8359 11.0391L18.9141 9.96094L12.5391 3.58594L12 3.07031Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol